import { action, atom } from "@reatom/core"
import { is } from "superstruct"
import isEqual from "lodash.isequal"

import { CatalogSearchQuery, defaultQuery } from "modules/PsyCatalog/common/searchQuery"
import { ctx } from "modules/PsyCatalog/common/ctx"
import { working_with } from "modules/PsyCatalog/common/searchQuery/schema"
import { FriendlyLabelsStorage } from "components/Labels"
import { Services } from "modules/PsyCatalog/common/services"

export function workingWithField({ UpdateUrl, CurrentQuery, FieldStatus }: Services) {
    const inputValue = atom<CatalogSearchQuery["working_with"]>(CurrentQuery.get().working_with)
    const update = action((ctx, key: keyof CatalogSearchQuery["working_with"]) => {
        inputValue(ctx, (state) => ({ ...state, [key]: !state[key] }))
    })
    const setValue = action((ctx, value: CatalogSearchQuery["working_with"]) => {
        inputValue(ctx, value)
    })

    function onChange(value: keyof CatalogSearchQuery["working_with"]) {
        update(ctx, value)
        UpdateUrl.run()
    }

    function parseValue(value: unknown) {
        return is(value, working_with) ? value : defaultQuery.working_with
    }

    function parseAndUpdate(value: unknown) {
        setValue(ctx, parseValue(value))
    }

    ctx.subscribe(inputValue, (value) => {
        if (!isEqual(value, defaultQuery.working_with)) {
            FriendlyLabelsStorage.saveFromFilters(value)
        }
        FieldStatus.setReady("working_with")
    })
    return { inputValue, onChange, update, parseAndUpdate, parseValue }
}
